module.exports = "<div class=triangle></div><div class=\"ns-popover-tooltip view_stations\"><p><b>You can travel from</b></p><ul><li ng-repeat=\"station in params.selectedOutwardTicketDetails.FromStations\">{{station}}</li><li ng-repeat=\"station in $ctrl.model.FromStations\">{{station}}</li></ul><p><b>You can travel to</b></p><ul><li ng-repeat=\"stationTo in params.selectedOutwardTicketDetails.ToStations\">{{stationTo}}</li><li ng-repeat=\"stationTo in $ctrl.model.ToStations\">{{stationTo}}</li></ul></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base/templates/ukrail/origin_stations.tmpl.html
// module id = 3713
// module chunks = 0